import React from 'react';
import FormModal from '../../../components/shared/FormModal';

function EventDetailsModal({ isOpen, onClose, event, onDeleteClick, onEditClick }) {
  if (!event) return null;

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Event Details"
      className="modal-medium"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a', margin: '0 0 6px 0' }}>
            {event.event_name}
          </h3>
          <div style={{ display: 'flex', gap: '12px', color: '#64748b', fontSize: '13px', fontWeight: '500' }}>
            <span>📅 {event.event_date}</span>
            <span>⏰ {event.event_time}</span>
          </div>
        </div>

        {event.description ? (
          <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', color: '#334155', fontSize: '14px', lineHeight: '1.5' }}>
            {event.description}
          </div>
        ) : (
          <div style={{ color: '#94a3b8', fontSize: '13px', fontStyle: 'italic' }}>
            No description provided.
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #f1f5f9' }}>
          {(event.type === 'event' || !event.type) ? (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                type="button"
                className="action-btn-outlined"
                onClick={() => {
                  onClose();
                  if (onEditClick) onEditClick(event);
                }}
              >
                Edit
              </button>
              <button
                type="button"
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#fef2f2',
                  color: '#ef4444',
                  border: '1px solid #fca5a5',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  onClose();
                  if (onDeleteClick) onDeleteClick(event);
                }}
              >
                Delete
              </button>
            </div>
          ) : (
            <div style={{ fontSize: '12px', color: '#64748b', fontStyle: 'italic' }}>
              🔒 Read-only ({event.category || 'System Item'}). Edits must be made in Note & Cases module.
            </div>
          )}
          
          <button
            type="button"
            className="action-btn-outlined"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </FormModal>
  );
}

export default EventDetailsModal;
